import MuubinBeneficiaryServices from '../../services/mubinApi/beneficiary';

export const state = {
    beneficiary: {},
    beneficiaries: [],
}

export const mutations = {
    setBeneficiary(state, beneficiary) {
        state.beneficiary = beneficiary
    },
    setBeneficiaries(state, beneficiaries) {
        state.beneficiaries = beneficiaries
    }
}

export const getters = {
    getBeneficiary(state) {
        return state.beneficiary;
    },
    getBeneficiaries(state) {
        return state.beneficiaries;
    },
}

export const actions = {
    get({commit}, id){
        return MuubinBeneficiaryServices.get(id)
        .then((response)=>{
            commit('setBeneficiary', response.data)
            return response
        })
    },
    getAll({commit}, data = {}){
        return MuubinBeneficiaryServices.getAll(data)
        .then((response)=>{
            commit('setBeneficiaries', response.data.data)
            return response
        })
    }
}